import "./JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons } from "./JSONToolsHeaderButtons";
import { JSONMultiDiffAPI } from "../../Services/APIService";
import { ExampleJSON } from "../../Services/Tools";
function JSONMultiDiff() {
    const navigate = useNavigate();
    const location = useLocation();

    const [baseJson, setBaseJson] = useState("");
    const [inputs, setInputs] = useState([""]);

    const toolFav = { toolName: "JSON Diff", Iconpath: "/GitDiffRaw.svg" };

    

    useEffect(() => {
        if (location.state?.baseJson && location.state?.inputs) {
            setBaseJson(location.state.baseJson);
            setInputs(location.state.inputs);
        }
    }, [location.state]);


    

    const addInput = () => {
        if (inputs.length >= 3) return;
        setInputs([...inputs, ""]);
    };

    const removeInput = (index) => {
        if (inputs.length === 1) return; // prevent removing last one
        const updated = inputs.filter((_, i) => i !== index);
        setInputs(updated);
    };

    const updateInput = (index, value) => {
        const updated = [...inputs];
        updated[index] = value;
        setInputs(updated);
    };


    const pasteExample = (type, index) => {
        const example =
            typeof ExampleJSON === "string"
                ? ExampleJSON
                : JSON.stringify(ExampleJSON, null, 2);

        if (type === "base") setBaseJson(example);
        else updateInput(index, example);
    };

    const computeDiff = async () => {
        if (!baseJson.trim() || inputs.length === 0) return;

        try {
            const payload = {
                baseJson: baseJson,
                compareWith: inputs.filter(i => i!== "" && i.trim())
            };


            const validInputs= inputs.filter(i => i!== "");
            console.log("Payload for diff API:", validInputs);
            const response = await JSONMultiDiffAPI(payload);
            const apiData = response?.data;

            if (!apiData) return;

            navigate("/json-diff-view", {
                state: {
                    baseJson,
                    inputs,
                    validInputs,
                    comparisons: apiData.comparisons || [],
                }
            });
        } catch (error) {
            console.error("Error:", error.response?.data?.message);
            alert("Error computing diff: " + (error.response?.data?.message || error.message));
            
        }
    };

    return (
        <Col className="json-multi-diff-page">
            {/* HEADER */}
            <ToolHeader title="JSON Diff" description="Compare a base JSON with multiple JSON inputs" toolFav={toolFav} />

            {/* BASE JSON */}
            <Row className="Formatter json-formatter-row">
                <FormatterPanel
                    title="Base JSON"
                    value={baseJson}
                    onChange={(e) => setBaseJson(e.target.value)}
                    placeholder="Paste base JSON here..."
                    lineCount={baseJson!== "" ?baseJson.split("\n").length:0}
                    panelStyle={{ width: "100%", height: "250px" }}
                    editorContainerStyle={{ overflow: "auto" }}
                    wrap={false}
                    headerButtons={
                        <InputHeaderButtons
                            primaryLabel="Example"
                            onPrimary={() => pasteExample("base")}
                            onClear={() => setBaseJson("")}
                            onImport={(file) => setBaseJson(file)}
                        />
                    }
                    footerLeft={`Characters : ${baseJson.replaceAll(" ", "").length}`}
                    footerRight={`Size : ${new Blob([baseJson]).size} B`}
                />
            </Row>

            {/* âœ… GRID INPUTS */}
            <Row
                className="multi-input-grid json-formatter-row"
                style={{
                    gridTemplateColumns: `repeat(${inputs.length}, 1fr)`
                }}
            >
                {inputs.map((input, index) => (
                    <div key={index} className="grid-item">
                        <FormatterPanel
                            title={`JSON ${index + 1}`}
                            value={input}
                            onChange={(e) => updateInput(index, e.target.value)}
                            placeholder="Paste JSON here..."
                            lineCount={input!== "" ?input.split("\n").length:0}
                            panelStyle={{ height: "250px", width: "inherit" }}
                            editorContainerStyle={{ overflow: "auto" }}
                            wrap={false}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={() => pasteExample("input", index)}
                                    onClear={() => updateInput(index, "")}
                                    onImport={(file) => updateInput(index, file)}
                                    accept=".json"
                                    onRemove={() => removeInput(index)}
                                    showRemove={inputs.length > 1}
                                />
                            }
                            footerLeft={`Characters : ${input.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([input]).size} B`}
                        />
                    </div>
                ))}
            </Row>

            <Row>
            {inputs.length < 3 && <Col className="add-json-btn" onClick={addInput}>
                + Add JSON to compare
            </Col>}
            </Row>

            {/* BOTTOM BAR */}
            
            <Row className="bottom-bar">
                <Col>
                <span>
                    Comparing Base JSON with {inputs.filter(i => i.trim()).length} input
                </span>
                </Col>
                <Col>
                <button className="compare-btn" onClick={computeDiff}>
                    Compare
                </button>
                </Col>
            </Row>
             
        </Col>
    );
}

export default JSONMultiDiff;
